export const boxShadow = {
  main: '0 0.0625rem 0.375rem 0 rgb(0 0 0 / 15%)'
};
